import PricesList from "./Views/List/List";
import PricesTabs from "./Views/Tabs/Tabs";
import PricesVehicle from "./Views/Vehicle/Vehicle";
import PricesNavigation from "./Views/Navigation/Navigation";
import moment from "moment/moment";
import RentalPages from "../../pages/Rent/RentalPages";
import PricesTabTools from "./Views/TabTools/TabTools";

const Prices = {

    changed: false,
    saved: true,
    editable: false,
    isAdmin: false,
    isPackageList: false,
    asyncUrl: null,

    init() {
        this.el = $('[page].Prices');
        if (!this.el.length) return;

        this.isEditable = this.el.is(".editable");
        this.alert = this.el.find(".Alert");
        this.changedDataStore = Prices.el.find("textarea#pricesData");

        this.start();
        this.bind();
    },

    start() {
        if (this.el.hasClass("admin")) {
            this.isAdmin = true;
        }

        PricesNavigation.init();
        PricesList.init();
        PricesTabs.init();
        PricesTabTools.init();

        this.isPackageList = Prices.getPriceListType() === 'packages';

        if (this.el.hasClass("admin")) {
            this.asyncUrl = this.isPackageList
                ? '/modules/rental_prices_packages/prices_packages.async.php'
                : '/modules/rental_prices/prices.async.php';
        }

        if (this.isEditable) {
            this.editable = true;
        }
    },

    bind() {
        window.addEventListener('beforeunload', function (e) {
            if (!Prices.isSaved()) {
                e.preventDefault();
            }
        });

        $(document).keydown(function (event) {
            if (event.ctrlKey && (event.key === "s" || event.key === "S")) {
                if (!Prices.isSaved()) {
                    event.preventDefault();
                    PricesTabTools.saveButton.trigger("click");
                }
            }
        });

        this.changedDataStore.on("change", function () {
            let value = $(this).val();

            if (value) {
                Prices.changed = true;
                Prices.saved = false;
                PricesTabTools.saveButton.addClass("visible");
            } else {
                PricesTabTools.saveButton.removeClass("visible");
                Prices.changed = false;
                Prices.saved = true;
            }
        });
    },

    setData(value) {
        this.changedDataStore.val(value).trigger("change");
    },

    getData() {
        return this.changedDataStore.val();
    },

    getPriceListType() {
        return this.changedDataStore.data('type');
    },

    reset(updateDefaultValues = false) {
        this.setData("");
        this.setEditable(false);

        Prices.changed = false;
        Prices.saved = true;

        if (updateDefaultValues) {
            // set default value to data-value if input val() changed, serves as default value if it is reset
            $("input.changed").each(function (index, el) {
                let newValue = $(el).val();
                $(el).data("value", newValue);
                $(el).attr("data-value", newValue);
            });
        }

        $.each(PricesList.el, function (index, section) {
            PricesVehicle.checkIfSectionsEmpty($(section));
            PricesVehicle.inactiveAddButton($(section));
            PricesList.resetSection($(section));
        });

        PricesList.el.find(".row.changed, .cell.changed, input.changed, div.categorySection.changed").removeClass("changed");
        PricesVehicle.removeNewRows();
    },

    setEditable(state = true) {

        Prices.editable = state;

        let section = $("section.PricesList");
        let inputs = section.find("input");

        if (Prices.editable) {
            inputs.prop("readonly", false);
            $(".cell.vehicle a").attr("tabindex", "-1");
        } else {
            inputs.prop("readonly", true);
            $(".cell.vehicle a").removeAttr("tabindex");
        }

        PricesTabTools.allowEditButton.toggleClass("active", Prices.editable);
        Prices.el.toggleClass("editable", Prices.editable);
    },

    save() {
        const page_id = window.ID_PAGE;
        const pathname = window.location.pathname;
        const event = $(this).data("event");
        const date_from = $(this).data("date_from");

        if (this.isLoading) {
            return;
        }

        let url = Prices.asyncUrl + `?go=${pathname}&event=${event}&page_id=${page_id}`;

        if (date_from) {
            url += `&date_from=${date_from}`;
        }

        $.ajax({
            type: 'POST',
            url: url,
            data: Prices.getData(),
            contentType: 'application/json',
            dataType: 'json',
            beforeSend: () => {
                this.isLoading = true;
            },
            success: (response, textStatus, jqXHR) => {
                this.isLoading = false;

                if (response.success === true) {
                    PricesTabTools.showAlert();
                    PricesList.el.find('.cell.asInput input').blur();

                    //  replace data-value with new value from input
                    $("input.changed").each(function (index, el) {
                        let newValue = $(el).val();
                        $(el).data("value", newValue);
                        $(el).attr("data-value", newValue);
                    });

                    if (response.inserted) {
                        $.each(response.inserted, function (key, value) {
                            let itemRow = $("#" + key);
                            let section = itemRow.closest("div.categorySection");

                            if (value.packages) {
                                $.each(value.packages, function (packageType, packageData) {
                                    let packageGroup = $("#" + key).find(packageType);
                                    packageGroup.find(".cell.deposit, .cell.daily").attr("item", packageData.recordID);
                                });
                            }

                            //TODO
                            itemRow.data("id", value.id)
                                .attr("data-id", value.id)
                                .removeAttr("id")
                                .removeClass("new empty ready");

                            itemRow.find(".cell.vehicle select, .cell.vehicle .chosen-container").remove();
                        });
                    }

                    if (response.menu) {
                        PricesNavigation.el.html(response.menu);
                        PricesNavigation.init();
                    }

                    if (response.content) {
                        setTimeout(() => {
                            let html = $('<div>').hide().empty().html(response.content);

                            $('.Prices .pricesContent [block="right"]').html(html.find(".pricesContent [block='right']").html());

                            PricesList.init();
                            Prices.bind();

                            RentalPages.init();
                        }, 500);
                    }

                    setTimeout(() => {
                        Prices.reset(true);
                    }, 200);
                } else {
                    console.error('Prices.save() failed')
                }
            },

            error: (xhr, status, error) => {
                console.error('Error:', error);
                // Handle error here if needed
            }
        })
    },

    isSaved() {
        return Prices.saved;
    },
}

export default Prices;

window.Prices = Prices;